// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  height: 82px;
  display: flex;
}
.trans-events {
  width: 100%;
  box-shadow: 0px 15px 42px rgba(0, 0, 0, 0.05);
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 5px 32px;
  margin-bottom: 32px;
  margin-top: 20px !important;
  text-align: left;

}
.web-trans-list {
  display: flex;
  align-items: center;
  width: 100%;
}
.trans-event-title{
font-size: 18px;
color: #424242;
}
.trans-event-date{
font-size: 14px;
color: #797979;
}
.trans-event-amt{
font-weight: 500;
font-size: 16px;
color: #68AD3F;
}
.trans-container{
  padding:0% 12%;
}
@media only screen and (min-width: 0px) and (max-width:480px) {
  .trans-events {
    padding: 5px 0px 5px 0px;
    align-items: flex-start;
    flex-direction: column;
    height: 100%;
  }
  .web-trans-list {
    display: none;
  }
  .trans-event-title{
    font-size: 14px;
    }
    .trans-event-date{
    font-size: 10px;
    }
    .trans-event-amt{
    font-size: 12px;
    }
    .trans-container{
      padding: 0% 6%;
    }
    .reg-close-trans{
      border-top: 1px solid #eaeaea;
      padding:5px 20px;
   }
}
@media only screen and (min-width: 481px) and (max-width: 767px) {
.trans-events {
  padding:5px 0px 5px 0px;
  align-items: flex-start;
  flex-direction: column;
  height: 100%;
}
.web-trans-list {
  display: none;
}
.trans-container{
  padding:0% 6%;
}
.trans-event-title{
  font-size: 14px;
  }
  .trans-event-date{
  font-size: 10px;
  }
  .trans-event-amt{
  font-size: 12px;
  }
  .trans-container{
    padding: 0% 6%;
  }
  .reg-close-trans{
    border-top: 1px solid #eaeaea;
    padding:5px 20px;
 }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .trans-event-title{
    font-size: 14px;
    }
    .trans-event-date{
    font-size: 10px;
    }
    .trans-event-amt{
    font-size: 12px;
    }
    .trans-container{
      padding:0% 6%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Parent/Trasaction-History/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,6CAA6C;EAC7C,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;;AAElB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;AACA,eAAe;AACf,cAAc;AACd;AACA;AACA,eAAe;AACf,cAAc;AACd;AACA;AACA,gBAAgB;AAChB,eAAe;AACf,cAAc;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf;IACA;IACA,eAAe;IACf;IACA;IACA,eAAe;IACf;IACA;MACE,cAAc;IAChB;IACA;MACE,6BAA6B;MAC7B,gBAAgB;GACnB;AACH;AACA;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf;EACA;EACA,eAAe;EACf;EACA;EACA,eAAe;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,6BAA6B;IAC7B,gBAAgB;CACnB;AACD;AACA;EACE;IACE,eAAe;IACf;IACA;IACA,eAAe;IACf;IACA;IACA,eAAe;IACf;IACA;MACE,aAAa;IACf;AACJ","sourcesContent":[".heading {\n  height: 82px;\n  display: flex;\n}\n.trans-events {\n  width: 100%;\n  box-shadow: 0px 15px 42px rgba(0, 0, 0, 0.05);\n  background-color: white;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 5px 32px;\n  margin-bottom: 32px;\n  margin-top: 20px !important;\n  text-align: left;\n\n}\n.web-trans-list {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.trans-event-title{\nfont-size: 18px;\ncolor: #424242;\n}\n.trans-event-date{\nfont-size: 14px;\ncolor: #797979;\n}\n.trans-event-amt{\nfont-weight: 500;\nfont-size: 16px;\ncolor: #68AD3F;\n}\n.trans-container{\n  padding:0% 12%;\n}\n@media only screen and (min-width: 0px) and (max-width:480px) {\n  .trans-events {\n    padding: 5px 0px 5px 0px;\n    align-items: flex-start;\n    flex-direction: column;\n    height: 100%;\n  }\n  .web-trans-list {\n    display: none;\n  }\n  .trans-event-title{\n    font-size: 14px;\n    }\n    .trans-event-date{\n    font-size: 10px;\n    }\n    .trans-event-amt{\n    font-size: 12px;\n    }\n    .trans-container{\n      padding: 0% 6%;\n    }\n    .reg-close-trans{\n      border-top: 1px solid #eaeaea;\n      padding:5px 20px;\n   }\n}\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n.trans-events {\n  padding:5px 0px 5px 0px;\n  align-items: flex-start;\n  flex-direction: column;\n  height: 100%;\n}\n.web-trans-list {\n  display: none;\n}\n.trans-container{\n  padding:0% 6%;\n}\n.trans-event-title{\n  font-size: 14px;\n  }\n  .trans-event-date{\n  font-size: 10px;\n  }\n  .trans-event-amt{\n  font-size: 12px;\n  }\n  .trans-container{\n    padding: 0% 6%;\n  }\n  .reg-close-trans{\n    border-top: 1px solid #eaeaea;\n    padding:5px 20px;\n }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .trans-event-title{\n    font-size: 14px;\n    }\n    .trans-event-date{\n    font-size: 10px;\n    }\n    .trans-event-amt{\n    font-size: 12px;\n    }\n    .trans-container{\n      padding:0% 6%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
